import { render, staticRenderFns } from "./RelAgendaConcluidos.vue?vue&type=template&id=5c0b30b9"
import script from "./RelAgendaConcluidos.vue?vue&type=script&lang=js"
export * from "./RelAgendaConcluidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports